export const getBrandName = (): string =>
  process.env.REACT_APP_WEBSITE_BRAND === 'vw5' || !process.env.REACT_APP_WEBSITE_BRAND
    ? 'vw'
    : process.env.REACT_APP_WEBSITE_BRAND;

export const brandType = ((): string => process.env.REACT_APP_BACKEND_BRAND ?? 'vw')();
export const bronsonBrand = ((): string => process.env.REACT_APP_WEBSITE_BRAND ?? 'vw')();
export const localeIdentifier = ((): string => process.env.REACT_APP_LOCALE ?? 'fr-FR')();

export const BASE_RESOURCE = 'base';

export const dateSeperator = '/';
export const currencySymbol = '€';
